import { Component, Inject, TemplateRef } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ic-factory-dialog',
  templateUrl: './factory-dialog.component.html',
  styleUrls: ['./factory-dialog.component.scss'],
})
export class FactoryDialogComponent<T> {
  constructor(
    public dialogRef: MatDialogRef<FactoryDialogComponent<T>>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      template: TemplateRef<any>;
      context: T;
    }
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }
}
